import React from "react";
import "./menu.scss";
import { useB2BContext } from "../context/ContextB2B";
import { NavLink } from "react-router-dom";

const navLinkClassName = ({ isActive }: { isActive: boolean }) =>
  isActive ? "active" : undefined;

function Menu() {
  const { getUserByID } = useB2BContext();
  const userType: any = localStorage.getItem("user_type");
  console.log(getUserByID,"getUserByID");
  

  return (
    <div className="menu">
      {userType === "Super_admin" ? (
        <>
          <div className={`item`}>
            <NavLink className={navLinkClassName} to="/demo-requests">Demo Requests</NavLink>
          </div>
          <div className={`item`}>
            <NavLink className={navLinkClassName} to="/linkgenerate">Demo Link Generate</NavLink>
          </div>
          <div className="menu_title">
            <p>Content Management</p>
          </div>
          <div className={`item sub_dropown`}>
            <p>SOULSARA Times</p>
            <div className="menu_dropdown_link">
              <div className="menu_title border_none">
                <p>SOULSARA Times</p>
              </div>
              <ul>
                <li>
                  <NavLink className={navLinkClassName} to="/thought">Thought for the week</NavLink>
                </li>
                <li>
                  <NavLink className={navLinkClassName} to="/featureditems">Featured items</NavLink>
                </li>
                <li>
                  <NavLink className={navLinkClassName} to="/latestvideos">Latest Videos</NavLink>
                </li>
                <li>
                  <NavLink className={navLinkClassName} to="/crisismanagementtools">
                    Crisis Management Tools
                  </NavLink>
                </li>
                <li>
                  <NavLink className={navLinkClassName} to="/womeninsports">Women In Sports</NavLink>
                </li>
                <li>
                  <NavLink className={navLinkClassName} to="/newsonwellness">News On Wellness</NavLink>
                </li>
                <li>
                  <NavLink className={navLinkClassName} to="/takeaway">Takeaway</NavLink>
                </li>
                <li>
                  <NavLink className={navLinkClassName} to="/times-featured-story">Featured Story</NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/themes">THEMES@SOULSARA</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/article">Theme Articles</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/forum">Community & Forum</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/blog">Blog Posts</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/news-flash">SSR News Flash</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/webinar">Webinar</NavLink>
          </div>
          <div className="item sub_dropown">
            <p>Event Videos</p>
            <div className="menu_dropdown_link">
              <div className="menu_title border_none">
                <p>Event Videos</p>
              </div>
              <ul>
                <li>
                  <NavLink className={navLinkClassName} to="/soulsaraeventvideos">Full Videos</NavLink>
                </li>
                <li>
                  <NavLink className={navLinkClassName} to="/soulsarashortvideos">Shorts</NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/approve-products">Approved Products</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/register_ngo">NGOs</NavLink>
          </div>
          <div className="menu_title">
            <p>Counseling Management</p>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/counselor-calendar">Counselor Calendar</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/recent-sessions">Recent Sessions</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/tawk-recent">Recent Tawk Sessions</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/helpline_history">Wellness Counseling Bookings</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/user-files-session-history">
              User Files & Sessions History
            </NavLink>
          </div>
          <div className="menu_title">
            <p>CSV Download</p>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/download-csv">Export CSV</NavLink>
          </div>
          <div className="menu_title">
            <p>Client Management</p>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/clients"> Clients</NavLink>
          </div>
          <div className="item sub_dropown">
            <p>Client Requests</p>
            <div className="menu_dropdown_link">
              <div className="menu_title border_none">
                <p>Client Requests</p>
              </div>
              <ul>
                <li>
                  <NavLink className={navLinkClassName} to="/membership-plan-change">
                    Membership Plan Change
                  </NavLink>
                </li>
                <li>
                  <NavLink className={navLinkClassName} to="/add-ons-change">Add-ons Change</NavLink>
                </li>
              </ul>
              <div className="menu_title border_none">
                <p>On Demand Service Requests</p>
              </div>
              <ul>
                <li>
                  <NavLink className={navLinkClassName} to="/exclusive-online-events">
                    Exclusive Online Events
                  </NavLink>
                </li>
                <li>
                  <NavLink to="#">Offline Group Training Sessions</NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/oca">Knowledge Hub Users</NavLink>
          </div>
        </>
      ) : userType === "Counselor" || userType === "Senior_counsellor" ? (
        <>
          <div className="menu_title">
            <p>Counseling Management</p>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/counselor-calendar">Counselor Calendar</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/helpline_history">Wellness Counseling Booking</NavLink>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/user-files-session-history">
              User Files & Sessions History
            </NavLink>
          </div>
        </>
      ) : (
        <>
          <div className="item">
            {getUserByID?.is_payment ? (
              <NavLink className={navLinkClassName} to="/overview">Overview</NavLink>
            ) : (
              <p>Overview</p>
            )}
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/subscription_agreement">Subscription Agreement</NavLink>
          </div>
         
          <div className="item">
            {getUserByID?.is_payment ? (
              <NavLink className={navLinkClassName} to="/departments">Manage Department</NavLink>
            ) : (
              <p>Manage Department</p>
            )}
          </div>
           <div className="item">
            {getUserByID?.is_payment ? (
              <NavLink className={navLinkClassName} to="/manage_exployees">Manage Employees</NavLink>
            ) : (
              <p>Manage Employees</p>
            )}
          </div>
          <div className="item">
            {getUserByID?.is_payment ? (
              <NavLink className={navLinkClassName} to="/insights">Insights</NavLink>
            ) : (
              <p>Insights</p>
            )}
          </div>
          <div className="item">
            {getUserByID?.is_payment ? (
              <NavLink className={navLinkClassName} to="/plan">Manage Plan</NavLink>
            ) : (
              <p>Manage Plan</p>
            )}
          </div>
          <div className="item">
            {getUserByID?.is_payment ? (
              <NavLink className={navLinkClassName} to="/hrprofile">Profile</NavLink>
            ) : (
              <p>Profile</p>
            )}
          </div>
          <div className="item">
            {getUserByID?.is_payment ? (
              <NavLink className={navLinkClassName} to="/on-demand-service">On Demand Services</NavLink>
            ) : (
              <p>On Demand Services</p>
            )}
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/2fa">Security</NavLink>
          </div>
          <div className="item">
            <NavLink
              to="https://www.soulsara.world/contact-us"
              target="_blank"
              rel="noreferrer"
            >
              Contact Us
            </NavLink>
          </div>
        </>
      )}
      {(userType === "Super_admin" ||
        userType === "Counselor" ||
        userType === "Senior_counsellor") && (
        <>
          <div className="menu_title">
            <p>Profile & Dashboard</p>
          </div>
          <div className="item">
            <NavLink className={navLinkClassName} to="/security">Security </NavLink>
          </div>
          {(userType === "Super_admin" || userType === "Senior_counsellor") && (
            <div className="item">
              <NavLink className={navLinkClassName} to="/roles-and-permissions">Roles & Permissions</NavLink>
            </div>
          )}
          {userType === "Super_admin" && (
            <div className="item">
              <NavLink className={navLinkClassName} to="/oca">User Wellness Dashboard</NavLink>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Menu;
